module.exports = __webpack_public_path__ + "img/trash.59c8713f.svg";